export const glassCTAData = {
  noMatch: {
    headline: "Can't find a firm?",
    description: "Check out our top recommended prop firms with exclusive offers just for you.",
    defaultText: "Get funded with a trusted prop firm"
  },

  default: {
    topHeadline: "Looking to Get Funded?",
    topDescription: "Join top prop firms and start trading today.",
    bottomHeadline: "Ready to Start Trading?",
    bottomDescription: "Pick a prop firm that matches your style.",
    promoHeadline: "Limited Time Prop Firm Offers!",
    promoDescription: "Get funded faster with exclusive promo codes.",
    defaultText: "Get funded with a top prop firm"
  },

  cti: {
    topHeadline: "Get Funded By CTI",
    topDescription: "Trade with real capital using City Traders Imperium programs.",
    bottomHeadline: "Why Trade with CTI?",
    bottomDescription: "Flexible evaluations with scaling plans up to $4M.",
    promoHeadline: "Exclusive CTI Offers Available!",
    promoDescription: "Get started with CTI today and grow your account.",
    defaultText: "Get funded with City Traders Imperium"
  },

  ttp: {
    topHeadline: "Join The Trading Pit Today",
    topDescription: "Multiple funding programs designed for every trader.",
    bottomHeadline: "Scaling up with TTP",
    bottomDescription: "Challenge yourself and grow your trading career.",
    promoHeadline: "Special Promo at The Trading Pit!",
    promoDescription: "Don't miss your chance to get funded.",
    defaultText: "Get funded with The Trading Pit"
  },

  e8: {
    topHeadline: "Start Trading with E8",
    topDescription: "Fast funding, transparent rules, flexible conditions.",
    bottomHeadline: "Why E8 Markets?",
    bottomDescription: "Up to $1M in funding with simple evaluations.",
    promoHeadline: "E8 Promo Live Now!",
    promoDescription: "Take advantage of E8 exclusive discounts.",
    defaultText: "Get funded with E8 Markets"
  },

  fxify: {
    topHeadline: "FXIFY Prop Firm Opportunity",
    topDescription: "Flexible funding models & up to 90% profit split.",
    bottomHeadline: "Trade Bigger with FXIFY",
    bottomDescription: "Choose between instant or evaluation funding.",
    promoHeadline: "Get Your FXIFY Discount!",
    promoDescription: "Start trading today with a reduced fee.",
    defaultText: "Get funded with FXIFY"
  },

  'alpha-capital': {
    topHeadline: "Alpha Capital Group Funding",
    topDescription: "Simple evaluation & scaling up to $1M.",
    bottomHeadline: "Alpha Capital Advantages",
    bottomDescription: "Grow your trading capital with flexible models.",
    promoHeadline: "Alpha Capital Promo Active!",
    promoDescription: "Get your discount code for Alpha Capital now.",
    defaultText: "Get funded with Alpha Capital Group"
  },

  'for-traders': {
  topHeadline: "Get Funded by For Traders",
  topDescription: "Flexible funding programs with instant funding available.",
  bottomHeadline: "Why Choose For Traders?",
  bottomDescription: "No daily drawdown on selected challenges & payouts in 48 hours.",
  promoHeadline: "For Traders Promo Active!",
  promoDescription: "Join now and explore various trading programs.",
  defaultText: "Get funded with For Traders"
  },

  'seacrest-funded': {
  topHeadline: "Get Funded by Seacrest Funded",
  topDescription: "Choose from 1-Step, 2-Step, Max or 3-Step challenges.",
  bottomHeadline: "Why Seacrest Funded?",
  bottomDescription: "Fast payouts, flexible rules, and scaling plan available.",
  promoHeadline: "Exclusive Seacrest Funded Offers!",
  promoDescription: "Start your trading journey today with Seacrest Funded.",
  defaultText: "Get funded with Seacrest Funded"
  }

}
